<template>
  <div class="ksk-stepper" :class="{ 'ksk-stepper--disabled': disabled }" v-bind="kskSlot('stepper')">
    <button
      type="button"
      class="ksk-stepper__btn ksk-stepper__btn--minus"
      :disabled="disabled || modelValue <= min"
      aria-label="Decrease"
      @click="change(-1)"
    >
      <span class="material-icons-round">remove</span>
    </button>
    <span class="ksk-stepper__value">{{ modelValue }}</span>
    <button
      type="button"
      class="ksk-stepper__btn ksk-stepper__btn--plus"
      :disabled="disabled || (max !== null && modelValue >= max)"
      aria-label="Increase"
      @click="change(1)"
    >
      <span class="material-icons-round">add</span>
    </button>
  </div>
</template>

<script>
import { kskSlot } from "@/config/kioskColorSlots";

// KSK004 — pill quantity stepper "– n +" with 64px round buttons.
export default {
  name: "KskStepper",
  emits: ["update:modelValue", "decrement", "increment"],
  props: {
    modelValue: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: null },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    kskSlot,
    change(delta) {
      const next = this.modelValue + delta;
      this.$emit(delta < 0 ? "decrement" : "increment", next);
      this.$emit("update:modelValue", next);
    },
  },
};
</script>

<style scoped>
.ksk-stepper {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ksk-space-2);
  height: 80px;
  min-width: 232px;
  padding: 0 8px;
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-surface-muted);
}
.ksk-stepper__btn {
  position: relative;
  width: 64px;
  height: 64px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  /* KSK063: stepper colour slot (outline = button ring, font = minus + number,
     accent = plus button); theme values otherwise. */
  border: 1px solid var(--ksk-slot-outline, var(--ksk-border));
  border-radius: 50%;
  background: var(--ksk-surface);
  color: var(--ksk-slot-font, var(--ksk-text));
  overflow: hidden;
  cursor: pointer;
  transition: transform 80ms ease-out;
  -webkit-tap-highlight-color: transparent;
}
.ksk-stepper__btn--plus {
  border-color: var(--ksk-slot-outline, transparent);
  background: var(--ksk-slot-accent, var(--ksk-primary));
  color: var(--ksk-on-primary);
}
.ksk-stepper__btn .material-icons-round {
  font-size: 32px;
}
.ksk-stepper__btn::after {
  content: "";
  position: absolute;
  inset: 0;
  background: currentColor;
  opacity: 0;
}
.ksk-stepper__btn:active:not(:disabled) {
  transform: scale(0.97);
}
.ksk-stepper__btn:active:not(:disabled)::after {
  opacity: 0.08;
}
.ksk-stepper__btn:disabled {
  background: var(--ksk-surface);
  border-color: var(--ksk-border);
  color: var(--ksk-border);
  cursor: not-allowed;
}
.ksk-stepper__value {
  min-width: 48px;
  text-align: center;
  font-size: var(--ksk-price-size);
  line-height: var(--ksk-price-lh);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--ksk-slot-font, var(--ksk-text));
}
</style>
